import { atom } from 'recoil';

export const favoriteExercisesState = atom<string[]>({
    key: 'favoriteExercisesState',
    default: [],
});
